// Ritual interactive whisker
(function () {
  const root = document.querySelector('[data-ritual]');
  if (!root) return;
  const steps = root.querySelectorAll('[data-ritual-step]');
  const bowl = root.querySelector('[data-ritual-bowl]');
  const whisk = root.querySelector('[data-ritual-whisk]');
  const label = root.querySelector('[data-ritual-label]');
  const stage = root.querySelector('[data-ritual-stage]');
  const next = root.querySelector('[data-ritual-next]');

  let current = 0;

  function setStep(i) {
    current = i % steps.length;
    steps.forEach((s, idx) => s.classList.toggle('active', idx === current));
    const fill = parseFloat(steps[current].dataset.stepFill) || 0;
    const jp = steps[current].dataset.stepJp;
    const title = steps[current].dataset.stepTitle;
    // re-render bowl SVG fill
    const fillH = (fill / 100) * 70;
    const fillY = 170 - fillH;
    const rect = bowl.querySelector('rect');
    if (rect) {
      rect.setAttribute('y', fillY);
      rect.setAttribute('height', 180);
    }
    if (label) label.innerHTML = `<span class="kanji" style="font-size:40px;margin-right:8px;">${jp}</span>${(title || '').toLowerCase()}`;
  }

  steps.forEach((s, i) => s.addEventListener('click', () => setStep(i)));
  if (next) next.addEventListener('click', () => setStep(current + 1));

  // shake-to-whisk
  let dragging = false, sx = 0, angle = 0;
  const onDown = (e) => {
    dragging = true;
    sx = (e.touches ? e.touches[0].clientX : e.clientX);
    if (whisk) whisk.style.top = '10%';
  };
  const onMove = (e) => {
    if (!dragging) return;
    const x = (e.touches ? e.touches[0].clientX : e.clientX);
    angle = Math.max(-15, Math.min(15, (x - sx) * 0.2));
    if (bowl) bowl.style.transform = `rotate(${angle}deg)`;
    if (whisk) whisk.style.transform = `translateX(-50%) rotate(${angle * 1.5}deg)`;
  };
  const onUp = () => {
    dragging = false;
    if (bowl) bowl.style.transform = '';
    if (whisk) { whisk.style.top = '16%'; whisk.style.transform = 'translateX(-50%)'; }
  };
  if (stage) {
    stage.addEventListener('mousedown', onDown);
    stage.addEventListener('touchstart', onDown);
  }
  window.addEventListener('mousemove', onMove);
  window.addEventListener('mouseup', onUp);
  window.addEventListener('touchmove', onMove);
  window.addEventListener('touchend', onUp);

  setStep(0);
})();
